import React from 'react';
import {
  Card, CardBody, Col
} from 'reactstrap';
import {withTranslation} from "react-i18next";
// import TrendingDownIcon from 'mdi-react/TrendingDownIcon';

const AssetIndicator = ({amount, asset, color_name, pending, t}) => (
  <Col md={12} xl={12} lg={12} xs={12}>
    <Card>
      <CardBody className="dashboard__booking-card">
        <div className="dashboard__booking-total-container">
          <h5 className={`dashboard__booking-total-title dashboard__booking-total-title--${color_name}`} >{amount}</h5>
          {(pending && parseFloat(pending) > 0) && <h5 className={`dashboard__booking-total-title--${color_name}`}>(+{pending} {t('overview.assets.in_rewards')})</h5>}
        </div>
        <h5 className="dashboard__booking-total-description">{asset}</h5>
      </CardBody>
    </Card>
  </Col>
);

export default withTranslation('dashboard')(AssetIndicator);
